import React from 'react';
import { LucideIcon, TrendingUp, TrendingDown } from 'lucide-react';

interface StatCardProps {
  title: string;
  value: string;
  change: string;
  isPositive?: boolean;
  icon: LucideIcon;
  iconColor: string;
  iconBg: string;
}

const StatCard: React.FC<StatCardProps> = ({ 
  title, 
  value, 
  change, 
  isPositive = true, 
  icon: Icon,
  iconColor,
  iconBg
}) => {
  return (
    <div className="bg-white p-8 rounded-[2rem] border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex justify-between items-start mb-6">
        <div className={`p-4 rounded-2xl ${iconBg} ${iconColor}`}>
          <Icon size={24} />
        </div>
        <div className={`flex items-center gap-1 px-2.5 py-1 rounded-lg text-xs font-bold ${
          isPositive ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600'
        }`}>
          {isPositive ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
          {change}
        </div>
      </div>
      <div>
        <p className="text-[#909090] text-sm font-semibold mb-1 uppercase tracking-wider">{title}</p>
        <p className="text-3xl font-bold text-[#121415] tracking-tight">{value}</p>
      </div>
    </div>
  );
};

export default StatCard;
